import React from 'react';
import { formatRelative } from '../../utils/dates';

function PeopleList({ people, onPersonClick }) {
  return (
    <div className="people-grid">
      {people.map(p => {
        const initial = p.person_name[0].toUpperCase();
        return (
          <div key={p.person_name} className="person-grid-card clickable" onClick={() => onPersonClick(p)}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12 }}>
              <div className="person-avatar">{initial}</div>
              <div>
                <div style={{ fontWeight: 600, fontSize: 14 }}>{p.person_name}</div>
                <div style={{ fontSize: 12, color: 'var(--text-muted)' }}>
                  {(p.roles || []).filter(Boolean).slice(0, 2).join(', ')}
                </div>
              </div>
            </div>
            <div style={{ fontSize: 12, color: 'var(--text-muted)', marginBottom: 8 }}>
              {p.mention_count} mención{p.mention_count !== 1 ? 'es' : ''}
            </div>
            {p.last_mentioned_at && (
              <div style={{ fontSize: 11, color: 'var(--text-dim)' }}>
                Última: {formatRelative(p.last_mentioned_at)}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}

export default PeopleList;
